import { buildCoordinates } from '../../../../shared/utils/map';
import { AddAlert } from '../../../../component';
import {
  getSectorsSocioeconomicDemographic,
  getBigNumbersSocioeconomicDemographic,
  getInfoWindowSocioeconomicDemographic,
} from './socioeconomicDemographic.infra';
import infoWindowSocioeconomicDemographic from './socioeconomicDemographic.infowindow';
import { loading, loaded } from '../../../../layout/redux/layoutActions';
import { decode } from '@googlemaps/polyline-codec';
import { clearDataLayers } from '../../dataLayers/controllers/dataLayers.controller';
import Map from 'eemovel-map-library/src/data/google-maps/map';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import Icon from '../../../../assets/img/CIRCLE-red-border.svg';
import ClusterIcon from '../../../../assets/img/Ellipse_39.svg';
import {
  clearMap,
  closeAllCharts,
  updateClusters,
  updateMarkers,
  modalOpen,
  setDisplayCharts,
} from '../../../dashboard/redux/dashboardActions';
import { setBigNumbers } from '../../bigNumbers/redux/bigNumbersActions';
import {
  closeInfoWindowsSocioeconomicDemographic,
  setInfoWindowsSocioeconomicDemographic,
  addGeocodeSocioeconomicDemographic,
  updateModalDataSocioeconomicDemographic,
  updateModalChartsSocioeconomicDemographic,
  updateModalTablesSocioeconomicDemographic,
  updateErrorFetchDataSocioeconomicDemographic,
  setShouldCleanPolygonsOnMap,
  updateChartsDataSocioeconomicDemographic,
  updateTablesDataSocioeconomicDemographic,
  resetErrorFetchData,
} from './socioeconomicDemographic.actions';
import {
  getTypesOfResidence,
  getResidenceCondition,
  getDwellersByResidence,
  getGenderDistribution,
  getAgeDistribution,
  getPopulationGrowth,
  getHouseholdsByIncome,
  getActivePopulation,
  getConsumptionByIncome,
  getConsumptionByGoods,
} from '../../charts/redux/charts.infra';
import { orderedKeysErrorStateSocioeconomicDemographic } from '../../../../shared/constants';
import { addIWListener } from '../../../../shared/utils/map';

let loadingStateController = {
  bigNumbers: false,
  sectors: false,
};

const formattingGeometry = (geometries, hasCentroid) => {
  if (hasCentroid) {
    return geometries.map((geo) => {
      return [
        {
          lat: geo?.centroid[1],
          lng: geo?.centroid[0],
        },
        geo.code,
      ];
    });
  }
  return geometries.map((geo) => {
    return {
      lat: geo[1],
      lng: geo[0],
    };
  });
};

const generateMarkersOnMap = (geometries) => {
  return (dispatch) => {
    const google = window.google;
    const centroids = formattingGeometry(geometries, true);
    const markers = centroids.map((centroid) => {
      const marker = new google.maps.Marker({
        position: centroid[0],
        map: Map.map,
        icon: Icon,
      });
      marker.addListener('click', function () {
        dispatch(generateInfoWindow(centroid[1], marker));
      });
      return marker;
    });
    const clusterOptions = {
      styles: [
        {
          url: ClusterIcon,
          height: 24,
          width: 24,
          textColor: '#FFF',
          fontWeight: 400,
          textSize: 14,
          anchorText: [5, 0],
        },
      ],
    };

    const map = Map.map;
    const markerCluster = new MarkerClusterer(map, markers, clusterOptions);
    dispatch(updateMarkers(markers));
    dispatch([updateMarkers(markers), updateClusters(markerCluster)]);
  };
};

export const generateInfoWindow = (sectorCode, marker) => {
  const payload = {
    sector_code: sectorCode,
  };

  return (dispatch) => {
    dispatch(loading());
    Promise.resolve(getInfoWindowSocioeconomicDemographic(payload))
      .then((res) => {
        dispatch(closeInfoWindowsSocioeconomicDemographic());
        const infowindow = infoWindowSocioeconomicDemographic({
          payload: res?.data,
          sectorCode,
          marker,
          map: Map.map,
          actions: [
            {
              id: 'IWButton',
              action: () => {
                dispatch(generateBuildingDetailsModal(sectorCode));
              },
            },
          ],
        });
        infowindow.open();
        dispatch([
          updateModalDataSocioeconomicDemographic({ info: res?.data }),
          setInfoWindowsSocioeconomicDemographic(infowindow.getInfowindow()),
        ]);
      })
      .catch((err) => {
        console.error(err);
        const payload = {
          domicile_type: '',
          total_domiciles: '',
          dwellers_per_household: '',
          total_population: '',
          family_income: '',
          age_group: '',
        };
        const iw = infoWindowSocioeconomicDemographic({
          payload,
          sectorCode,
          marker,
          map: Map.map,
        });
        iw.open();
        dispatch(setInfoWindowsSocioeconomicDemographic(iw.getInfowindow()));
      })
      .finally(() => dispatch(loaded()));
  };
};

export const mapPolygonsDrawer = () => {
  return (dispatch) => {
    const locationCoordinates = buildCoordinates();
    if (!locationCoordinates) {
      dispatch(AddAlert('warning', 'Selecione uma área no mapa'));
      return false;
    }
    dispatch(loading());
    let censusSectorsPayload = {};

    if (locationCoordinates.radius) {
      censusSectorsPayload = {
        location: {
          location_point: locationCoordinates?.coordinates,
          radius: locationCoordinates?.radius,
        },
      };
    } else {
      censusSectorsPayload = {
        location: {
          coordinates: locationCoordinates?.coordinates,
        },
      };
    }

    const google = window.google;
    const allPolygons = [];
    let error = false;
    const allCentroids = [];

    Promise.resolve(getSectorsSocioeconomicDemographic(censusSectorsPayload))
      .then((response) => {
        const areas = response?.data;
        const sectors = areas.map((area) => {
          const unformattedGeometry = decode(area?.geometry);
          const geometry = formattingGeometry(unformattedGeometry, false);
          dispatch(addGeocodeSocioeconomicDemographic(area?.geocodi));
          return {
            ...area,
            geometry,
          };
        });

        dispatch([
          clearMap(),
          clearDataLayers(),
          closeAllCharts(),
          setShouldCleanPolygonsOnMap(true),
        ]);
        sectors.forEach((sector) => {
          allPolygons.push(sector?.geometry);
          if (sector?.centroid !== null && sector.hasOwnProperty('centroid')) {
            allCentroids.push({
              centroid: sector?.centroid[0],
              code: sector?.geocodi,
            });
          }
        });
      })
      .catch(() => {
        dispatch(setDisplayCharts(null));
        dispatch(
          AddAlert('error', 'Não foi possível encontrar os dados no momento.')
        );
        error = true;
      })
      .finally(() => {
        const newPolygon = new google.maps.Polygon({
          paths: allPolygons,
          strokeColor: '#000000',
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: '#383939',
        });
        if (!error) {
          newPolygon.setMap(Map.map);
          Map.PoligonOnMap = newPolygon;
          dispatch([generateMarkersOnMap(allCentroids)]);
        }
        loadingStateController.sectors = true;
        if (loadingStateController.bigNumbers) {
          dispatch(loaded());
          loadingStateController.sectors = false;
          loadingStateController.bigNumbers = false;
        }
      });
    return true;
  };
};
export const getSocioeconomicChartsData = (geocodePayload) => {
  const payload = {
    sector_ids: geocodePayload,
  };
  return (dispatch) => {
    dispatch([resetErrorFetchData(), loading()]);
    Promise.all([
      getTypesOfResidence(payload),
      getResidenceCondition(payload),
      getDwellersByResidence(payload),
      getGenderDistribution(payload),
      getAgeDistribution(payload),
      getPopulationGrowth(payload),
      getHouseholdsByIncome(payload),
      getActivePopulation(payload),
      getConsumptionByIncome(payload),
      getConsumptionByGoods(payload),
    ])
      .then((response) => {
        dispatch([
          updateChartsDataSocioeconomicDemographic({
            name: 'typesOfResidence',
            value: response[0]?.data,
          }),
          updateChartsDataSocioeconomicDemographic({
            name: 'residenceCondition',
            value: response[1]?.data,
          }),
          updateChartsDataSocioeconomicDemographic({
            name: 'dwellersByResidence',
            value: response[2]?.data,
          }),
          updateChartsDataSocioeconomicDemographic({
            name: 'genderDistribution',
            value: response[3]?.data,
          }),
          updateTablesDataSocioeconomicDemographic({
            name: 'ageDistribution',
            value: response[4]?.data,
          }),
          updateTablesDataSocioeconomicDemographic({
            name: 'populationGrowth',
            value: response[5]?.data,
          }),
          updateTablesDataSocioeconomicDemographic({
            name: 'householdsByIncome',
            value: response[6]?.data,
          }),
          updateChartsDataSocioeconomicDemographic({
            name: 'activePopulation',
            value: response[7]?.data,
          }),
          updateTablesDataSocioeconomicDemographic({
            name: 'consumptionByIncome',
            value: response[8]?.data,
          }),
          updateChartsDataSocioeconomicDemographic({
            name: 'consumptionByGoods',
            value: response[9]?.data,
          }),
        ]);
        response.forEach((elem, index) => {
          if (!elem?.data) {
            dispatch(
              updateErrorFetchData({
                name: orderedKeysErrorStateSocioeconomicDemographic[index],
                value: true,
              })
            );
          }
        });
      })
      .finally(() => {
        dispatch(loaded());
      });
  };
};

const generateBigNumbers = (dispatch, res) => {
  const bigNumbers = res?.data || {};
  dispatch([
    setBigNumbers(bigNumbers),
    setDisplayCharts('socioeconomicDemographic'),
  ]);
};

export const searchSocioeconomicDemographicProfile = (payload) => {
  const coordinates = buildCoordinates();
  return (dispatch) => {
    if (!coordinates) {
      dispatch(AddAlert('warning', 'Geometria inválida'));
      return;
    }
    dispatch(loading());
    Promise.resolve(
      getBigNumbersSocioeconomicDemographic({
        coordinates: coordinates.coordinates,
        ...(coordinates.radius ? { radius: coordinates.radius } : {}),
      })
    )
      .then((response) => {
        generateBigNumbers(dispatch, response);
      })
      .catch((e) => {
        dispatch(setDisplayCharts(null));
        dispatch(
          AddAlert('error', 'Algo deu errado. Tente novamente mais tarde!')
        );
      })
      .finally(() => {
        loadingStateController.bigNumbers = true;
        if (loadingStateController.sectors) {
          dispatch(loaded());
          loadingStateController.sectors = false;
          loadingStateController.bigNumbers = false;
        }
      });
  };
};

export const generateBuildingDetailsModal = (sectorId) => {
  const payload = {
    sector_ids: [sectorId],
  };
  return (dispatch) => {
    dispatch(loading());
    Promise.all([
      getTypesOfResidence(payload),
      getResidenceCondition(payload),
      getDwellersByResidence(payload),
      getGenderDistribution(payload),
      getAgeDistribution(payload),
      getPopulationGrowth(payload),
      getHouseholdsByIncome(payload),
      getActivePopulation(payload),
      getConsumptionByIncome(payload),
      getConsumptionByGoods(payload),
    ])
      .then((res) => {
        dispatch([
          updateModalChartsSocioeconomicDemographic({
            typesOfResidence: res[0]?.data,
            residenceCondition: res[1]?.data,
            dwellersByResidence: res[2]?.data,
            genderDistribution: res[3]?.data,
            activePopulation: res[7]?.data,
            consumptionByGoods: res[9]?.data,
          }),
          updateModalTablesSocioeconomicDemographic({
            ageDistribution: res[4]?.data,
            populationGrowth: res[5]?.data,
            householdsByIncome: res[6]?.data,
            consumptionByIncome: res[8]?.data,
          }),
          updateModalDataSocioeconomicDemographic({ sector: sectorId }),
          modalOpen('open building socioeconomic demographic'),
        ]);
        res.forEach((elem, index) => {
          if (!elem?.data) {
            dispatch(
              updateErrorFetchDataSocioeconomicDemographic({
                name: orderedKeysErrorStateSocioeconomicDemographic[index],
                value: true,
              })
            );
          }
        });
      })
      .finally(() => dispatch(loaded()));
  };
};
